export default __webpack_public_path__ + "static/anastacia-94ae6e458c5fbe85dfef5003a25aa64a.webp";